import { ProviderSummary } from '../providers/provider.types';
import { ActivityType, MetaStatus } from '../meta/meta.types';
import { GeoLocation, PagedFilter, ProductPrice } from '../common/common.types';
import { EnumExtensions, EnumValue } from '../common/enum.consts';
import { ProviderDeal } from '../providers/deals/provider-deal.types';

export class ProductFilter extends PagedFilter {
  activityTypeId?: number;
  statuses?: MetaStatus[];
  attendeeTotal?: number;
  currencyCode?: string;
  searchTerm?: string;
  location?: GeoLocation;
}

export class Product {
  productId: number;
  status: MetaStatus;
  activityType: ActivityType;
  provider: ProviderSummary;
  name: string;
  summary?: string;
  prices?: ProductPrice[];
  costs?: ProductPrice[];
  location?: GeoLocation;

  duration?: number;
  attendeesMin?: number;
  attendeesMax?: number;
  needsBooking?: boolean;
  paymentMethod?: ProductPaymentMethod;
  deals: ProviderDeal[];
}

export class UpdatedProduct {
  activityTypeId: number;
  name: string;
  summary?: string;

  prices?: ProductPrice[];
  costs?: ProductPrice[];
  location?: GeoLocation;

  duration?: number;
  attendeesMin?: number;
  attendeesMax?: number;
  needsBooking?: boolean;
  paymentMethod?: ProductPaymentMethod;
}

export class NewProduct extends UpdatedProduct {
  providerId: number;
}

export enum ProductPaymentMethod {
  DirectDebit = 1,
  Invoice = 2,
  CallToPay = 3,
}

export class Where {
  city: string;
  state: string;
  country: string;
  timeZoneId?: string;
}

export class ProductV2 {
  id: string;
  name: string;
  productCities: Where[];
  wheres: Where[];

}

export function ProductPaymentMethodName(method: ProductPaymentMethod): string {
  switch (method) {
    case ProductPaymentMethod.DirectDebit:
      return 'Direct Debit';
    default:
      return ProductPaymentMethod[method];
  }
}

export const ProductPaymentMethodValues: EnumValue<
  ProductPaymentMethod
>[] = EnumExtensions.getMappedNamesAndValues<ProductPaymentMethod>(
  ProductPaymentMethod,
  ProductPaymentMethodName
);
